// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7ad58990","787":"aadca95f","796":"95f5812a"}[chunkId] + ".chunk.js";
};